/**
 * Route guard: allows render only when {@link canAccessModule} passes for `moduleKey`.
 *
 * Thin React wrapper around {@link ../modules/appModuleAccess.js} — no policy logic here.
 * Used by {@link ./Routes.jsx} for every private module route (flat and shell).
 *
 * Waits for `userData` hydration (returns `null` until loaded). On deny, redirects using
 * `decision.redirectTo` or {@link getAccessDeniedRedirectPath}.
 *
 * @module routes/RequireModuleAccess
 */

import { Navigate, useLocation } from "react-router-dom";
import {
  getAccessDeniedRedirectPath,
  getModuleAccessDecision,
} from "modules/appModuleAccess";
import useAuthStore from "stores/useAuthStore";
import { logReturnUrlFlow } from "auth/returnUrlDebug";

/**
 * @param {Object} props
 * @param {string} props.moduleKey — {@link APP_MODULE_KEYS} value from registry
 * @param {React.ReactNode} props.children — page or shell root to render when allowed
 */
export default function RequireModuleAccess({ moduleKey, children }) {
  const userData = useAuthStore((s) => s.userData);
  // const location = useLocation();

  // AuthStoreHydrator has not finished — avoid a false redirect.
  if (!userData) return null;

  const decision = getModuleAccessDecision(moduleKey, userData);
  // logReturnUrlFlow("RequireModuleAccess:decision", {
  //   currentPath: `${location.pathname}${location.search}${location.hash}`,
  //   moduleKey,
  //   allowed: decision.allowed,
  //   reason: decision.reason,
  //   redirectTo: decision.redirectTo,
  //   fallbackRedirectTo: getAccessDeniedRedirectPath(userData),
  //   role: userData?.role,
  //   modules: userData?.modules,
  // });

  if (!decision.allowed) {
    return (
      <Navigate
        to={decision.redirectTo || getAccessDeniedRedirectPath(userData)}
        replace
      />
    );
  }

  return children;
}
